module.exports = __webpack_public_path__ + "media/images/app_logo/72-178ae4e8434f159765e321159c7dad69.png";